import { ForkFrozenSandboxModal } from './ForkFrozenSandboxModal';

export default ForkFrozenSandboxModal;
